module.exports = {
  'Evaluate patient’s pre-existing symptoms.':'Evaluate patient’s pre-existing symptoms.',
  'Evaluate new symptoms as possible ADRs':'Evaluate new symptoms as possible ADRs',
  'Stopping the medication ':'Stopping the medication ',
  'Lab Investigation':'Lab Investigation',
  'Apply probability tools':'Apply probability tools',
  'Social Support':'Social Support',
  'Reduce dosing or discontinue the offending medication.':'Reduce dosing or discontinue the offending medication.',
  'Switch to another agent or dosage form less likely to cause ADRs.':'Switch to another agent or dosage form less likely to cause ADRs.',
  'Treat side effects when necessary ':'Treat side effects when necessary '
};
